import Model from './BaseModel';
import Race from './Race';
import BetType from './TrackBetType';

export default class Meeting extends Model {
	resourceName() {
		return 'meetings';
	}

	fields() {
		return [
			'bonus_disabled',
			'boostable',
			'country',
			'name',
			'number_of_race',
			'race_type',
			'start_date',
			'start_time',
			'state',
			'track',
			'visible',
			'weather',
			'order',
			'cashout_enabled',
			'fees'
		];
	}

	relationships() {
		return {
			races: new Race(),
			bet_types: new BetType()
		};
	}

	// custom update
	update(data) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}`,
			method: 'POST',
			data
		});
	}
}
